// extracted by mini-css-extract-plugin
module.exports =  {"styledDropdown":"ChatInputDropdown-module__styledDropdown--GqCK6"};